export class TotalMonthlyPayments {
    constructor(form) {
        this._totalMonthlyPaymentsSelector = ".js-total-monthly-payments";
        this._paymentTypeSelector = ".js-payment-type";
        this.form = form;
        this.totalMonthlyPayments = this.findTotalMonthlyPayments();
        this.paymentType = this.findPaymentType();
        this.paymentType.addEventListener("change", () => {
            this.updateMonthlyPayments();
        });
        this.updateMonthlyPayments();
    }
    updateMonthlyPayments() {
        const { isSingle } = this.paymentType.selectedOptions[0].dataset;
        if (isSingle === "true") {
            this.totalMonthlyPayments.value = "1";
        }
        else {
            this.totalMonthlyPayments.value = "";
        }
    }
    findPaymentType() {
        const paymentType = this.form.querySelector(this._paymentTypeSelector);
        if (paymentType === null) {
            throw new Error("Payment type element not found");
        }
        return paymentType;
    }
    findTotalMonthlyPayments() {
        const totalMonthlyPayments = this.form.querySelector(this._totalMonthlyPaymentsSelector);
        if (totalMonthlyPayments === null) {
            throw new Error("Total monthly payments element not found");
        }
        return totalMonthlyPayments;
    }
    // Method create that returns a new instance of TotalMonthlyPayments and receives a form as a parameter
    static create(form) {
        return new TotalMonthlyPayments(form);
    }
}
